










import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color } from "../../../../../../../base/domain/drawing";
import { FormatObjectPropertyEditor } from "../contents";
import { NewObjectLocatableMixin } from "./mixins";

@Component({
  components: {
    FormatObjectPropertyEditor,
  },
})
export default class VectorObjectLocator extends Mixins(NewObjectLocatableMixin) {
  @Prop()
  pallet: Color[];


  mounted(): void {
    this.start();
  }

  start(): void {
    this.process = () => this.layoutLinear();
  }
}
